import { actionType } from "../actions/internkoderMiljogebyrActions";
import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = [];
const internkoderMiljogebyrReducer = (state = INITIAL_STATE, action) =>
  CreateNewReducer(state, action, actionType);

export default internkoderMiljogebyrReducer;
